export interface BidRequest {
  id: string;
  sevkKodu: string;
  loadingPoint: string;
  loadingCity: string;
  loadingAddress: string;
  deliveryPoint: string;
  deliveryCity: string;
  deliveryAddress: string;
  cargoType: string;
  cargoWeight: number;
  cargoVolume: number;
  distance: number;
  plannedLoadingTime: string;
  plannedDeliveryTime: string;
  status: 'open' | 'closed' | 'awarded' | 'cancelled';
  minimumBid?: number; // En düşük teklif tutarı
  currentLowestBid?: number; // Şu anki en düşük teklif
  bidCount: number; // Teklif sayısı
  bidDeadline: string; // Teklif verme son tarihi
  createdAt: string;
  createdBy: string;
  requireReferenceWaybill?: boolean;
  phoneOnlyQuote?: boolean;
  loadingContactPhone?: string;
  shipmentContactPhone?: string;
  awardedBidId?: string; // Kazanan teklif
  awardedDriverId?: string; // Kazanan sürücü
}

export interface Bid {
  id: string;
  bidRequestId: string;
  driverId: string;
  driverName: string;
  driverCompany?: string;
  amount: number; // Teklif tutarı
  vehiclePlate?: string;
  vehicleType?: string;
  notes?: string;
  status: 'pending' | 'accepted' | 'rejected' | 'withdrawn';
  createdAt: string;
  updatedAt: string;
}

export interface BidWithRequest extends Bid {
  bidRequest: BidRequest;
}

export const BID_STATUS_CONFIG = {
  pending: {
    label: 'Beklemede',
    color: '#F59E0B',
    bgColor: '#FEF3C7',
    icon: 'clock',
  },
  accepted: {
    label: 'Kabul Edildi',
    color: '#10B981',
    bgColor: '#D1FAE5',
    icon: 'check-circle',
  },
  rejected: {
    label: 'Reddedildi',
    color: '#EF4444',
    bgColor: '#FEE2E2',
    icon: 'x-circle',
  },
  withdrawn: {
    label: 'Geri Çekildi',
    color: '#6B7280',
    bgColor: '#F3F4F6',
    icon: 'minus-circle',
  },
};

export const BID_REQUEST_STATUS_CONFIG = {
  open: {
    label: 'Teklif Alınıyor',
    color: '#10B981',
    bgColor: '#D1FAE5',
    description: 'Aktif olarak teklif toplanıyor',
  },
  closed: {
    label: 'Teklif Kapalı',
    color: '#6B7280',
    bgColor: '#F3F4F6',
    description: 'Teklif süresi sona erdi',
  },
  awarded: {
    label: 'Tekif Talebi Sonuçlandı',
    color: '#3B82F6',
    bgColor: '#DBEAFE',
    description: 'Teklif kazanıldı ve iş atandı',
  },
  cancelled: {
    label: 'İptal Edildi',
    color: '#EF4444',
    bgColor: '#FEE2E2',
    description: 'Teklif Talebi iptal edildi',
  },
};
